export default "__VITE_ASSET__8QVE4tZw__"